var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0084 16.9442C12.0246 16.9442 12.8483 16.2274 12.8483 15.1313V7H15.0548C14.931 8.48292 16.427 9.91539 18.0769 9.88262V11.9271C16.6659 11.9271 15.4661 11.3392 15.0485 11.0129V15.1313C15.0485 16.9442 13.6011 19 11.0084 19C8.41578 19 7 16.9442 7 15.1313C7 12.5725 9.74802 11.0885 11.5681 11.4512V13.5337C11.4765 13.5017 11.2404 13.4545 11.0393 13.4545C10.0147 13.4173 9.16862 14.2361 9.16862 15.1313C9.16862 16.1325 9.99234 16.9442 11.0084 16.9442Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 0C5.59639 0 0 5.59639 0 12.5C0 19.4036 5.59639 25 12.5 25C19.4031 25 25 19.4033 25 12.5C25 5.59667 19.4033 0 12.5003 0ZM12.5003 22.5C6.97778 22.5 2.5 18.0225 2.5 12.5C2.5 6.97778 6.9775 2.5 12.5 2.5C18.0222 2.5 22.5 6.97778 22.5 12.5C22.5003 18.0225 18.0225 22.5 12.5003 22.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.6b513007.svg";
export { ForwardRef as ReactComponent };